<div
  #subList
  class="nav-sub-list"
  [ngClass]="{
    'sub-list-open': viewModel.isNavListActive$ | async
  }">
  @for (subItem of navItem?.subItems; track subItem.name) {
    @if (subItem | isDefaultNavSubItem) {
      <app-nav-sub-item [navItem]="navItem" [subItem]="subItem" [currentNavUrl]="currentNavUrl"> </app-nav-sub-item>
    }
    @if (subItem | isProductGroupNavSubItem) {
      <app-product-groups-sub-nav-item [navItem]="navItem" [subItem]="subItem" [currentNavUrl]="currentNavUrl">
      </app-product-groups-sub-nav-item>
    }
    @if (subItem | isUniversalVariantsNavSubItem) {
      <app-universal-variants-sub-nav-item [navItem]="navItem" [subItem]="subItem" [currentNavUrl]="currentNavUrl">
      </app-universal-variants-sub-nav-item>
    }
  }
</div>
